import { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import Header from "../../component/Header";
import DiamondsFour from "../../component/SvgIcons/DiamondsFour";
import api from "../../services/axios";
import { AnimatePresence, motion } from "framer-motion";
import { useSwal } from "../../services/SweetAlert";
import utils, { phonePattern } from '../../utils/utils'
import IconError from "../../component/SvgIcons/IconError";
// import {View}

export default function EditCustomerDetails() {
  const { cust_code } = useParams();
  const navigate = useNavigate();
  const [rowData, setRowData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("user")); 
  const { alert } = useSwal();
  useEffect(() => {
    utils.saveRecentSearch('Edit Customer Details', window.location.pathname)
  }, [])

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const res = await api.post(`/view_customer/${cust_code}`);
        console.log("Customer data:", res.data.data);
        
        if (res.data.data) {
          setRowData(res.data.data);
        } else {
          console.warn("Unexpected data format:", res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch customer:", error);
      }
    };
    fetchCustomer();
  }, [cust_code]);

    const getFieldError = (name, value) => {
    switch (name) {
      case "Code":
        return !value?.trim() ? "Code is required." : "";
      case "Customer_Name":
        return !value?.trim() ? "Customer Name is required." : "";
      case "Location":
        return !value?.trim() ? "Location is required." : "";
      case "Designation":
        return !value?.trim() ? "Designation is required." : "";
      case "Address":
        return !value?.trim() ? "Address is required." : "";
      case "City":
        return !value?.trim() ? "City is required." : "";
      case "State":
        return !value?.trim() ? "State is required." : "";
      case "Customer_Type":
        return !value ? "Customer Type is required." : "";

      case "Contact_Mobile_No":
      if (!value?.trim()) return ""; // Optional field
      return phonePattern(value.trim()) ? "" : "Invalid mobile number.";

      default:
        return "";
    }
  };

   const validateField = (name, value) => {
    const error = getFieldError(name, value);
    setFormErrors((prev) => ({ ...prev, [name]: error }));
    return !error;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRowData((prev) => ({ ...prev, [name]: value }));
    validateField(name, value);
  };

  const handleCustomerTypeChange = (type) => {
    setRowData((prev) => ({
      ...prev,
      Customer_Type: prev.Customer_Type === type ? "" : type,
    }));
    validateField("Customer_Type", type);
  };

const handleSubmit = async (e) => {
  e.preventDefault();


  const requiredFields = [
    "Code", "Customer_Name", "Location", "Designation",
    "Address", "City", "State", "Customer_Type", "Contact_Mobile_No"
  ];

  const newErrors = {};
  let isValid = true;

  requiredFields.forEach((field) => {
    const error = getFieldError(field, rowData[field]);
    if (error) {
      isValid = false;
      newErrors[field] = error;
    }
  });

  setFormErrors(newErrors);

  if (!isValid) {
    alert("error", "Please fill in all required fields correctly.");
    return;
  }
  
  try {
    setLoading(true);

    // Add UpdatedBy field here
    const updatedData = {
      ...rowData,
      Updatedby: user?.Code || user?.Code || "",
    };
   console.log("Payload to update customer:", updatedData);
   

    const res = await api.post(`/update_customer`, updatedData);
    await alert("success", res.data.message);

    console.log("Customer updated successfully:", res.data);
    navigate("/customers-list"); // redirect after success
  } catch (error) {
    setLoading(false);
    console.error("Failed to update customer:", error);
  }
};


  return (
    <div className="dashboard">
      <Header title subtitle="Edit Customers Details" backbtn="/customers-list" searchbar/>
      <div className="center-content">
        <div className="container">
          <div className="pagegap d-flex flex-column">
            <h2 className="create-titles mb-0 d-flex align-items-center">
              <DiamondsFour /> <span>Edit Customer Details</span>
            </h2>

            <AnimatePresence mode="wait">
              <motion.form
                className="customerform myform d-flex flex-column justify-content-between"
                onSubmit={handleSubmit}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
              >
                <div className="create-form d-flex flex-column">
                  <div className="form-row d-flex justify-content-start justify-content-lg-between flex-wrap flex-xl-nowrap flex-column flex-lg-row">
                    <div className={`form-group ${formErrors.Customer_Name ? "fieldrequire" : ""}`}>
                      <label>Customer Name <span className="required-asterisk">*</span></label>
                      <input
                        type="text"
                        name="Customer_Name"
                        className="form-control"
                        placeholder="Enter Name"
                        value={rowData.Customer_Name || ""}
                      />
                       <small className="hide"><IconError/></small>   
                    </div>
                     <div className={`form-group ${formErrors.Code ? "fieldrequire" : ""}`}>
                      <label>Code <span className="required-asterisk">*</span></label>
                      <input
                        type="text"
                        name="Code"
                        className="form-control"
                        placeholder="Enter Code"
                        value={rowData.Code || ""}
                      />
                       <small className="hide"><IconError/></small> 
                    </div>
                    <div className="form-group">
                      <label>Serial Number</label>
                      <input
                        type="text"
                        name="Serial_No"
                        className="form-control"
                        placeholder="Enter Serial Number"
                        value={rowData.Serial_No || ""}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>

                  <div className="form-row d-flex justify-content-start justify-content-lg-between flex-wrap flex-xl-nowrap flex-column flex-lg-row">
                    
                  <div className={`form-group ${formErrors.Designation ? "fieldrequire" : ""}`}>
                      <label>Designation <span className="required-asterisk">*</span></label>
                      <input
                        type="text"
                        name="Designation"
                        className="form-control"
                        placeholder="Enter Designation"
                         value={rowData.Designation || ""}
                        onChange={handleInputChange}
                      />
                    <small className="hide"><IconError/></small>   
                    </div>

                  
                   <div className={`form-group ${formErrors.Location ? "fieldrequire" : ""}`}>
                      <label>Location <span className="required-asterisk">*</span></label>
                      <input
                        type="text"
                        name="Location"
                        className="form-control"
                        placeholder="Enter Location"
                        value={rowData.Location || ""}
                        onChange={handleInputChange}
                      />
                      <small className="hide"><IconError/></small> 
                    </div>
                    <div className={`form-group ${formErrors.City ? "fieldrequire" : ""}`}>
                      <label>City <span className="required-asterisk">*</span></label>
                      <input
                        type="text"
                        name="City"
                        className="form-control"
                        placeholder="Enter City"
                        value={rowData.City || ""}
                        onChange={handleInputChange}
                      />
                      <small className="hide"><IconError/></small> 
                    </div>              
                  </div>
                <div className="form-row d-flex justify-content-start justify-content-lg-between flex-wrap flex-xl-nowrap flex-column flex-lg-row">
                <div className={`form-group ${formErrors.State ? "fieldrequire" : ""}`}>
                      <label>State <span className="required-asterisk">*</span></label>
                      <input
                        type="text"
                        name="State"
                        className="form-control"
                        placeholder="Enter State"
                        value={rowData.State || ""}
                        onChange={handleInputChange}
                      />
                       <small className="hide"><IconError/></small> 
                    </div>
                      <div className={`form-group ${formErrors.Address ? "fieldrequire" : ""}`}>
                        <label>Address <span className="required-asterisk">*</span></label>
                        <input
                          type="text"
                          name="Address"
                          className="form-control"
                          placeholder="Enter Address"
                          value={rowData.Address || ""}
                          onChange={handleInputChange}
                        />
                        <small className="hide"><IconError/></small> 
                      </div>

                      <div className="form-group">
                      <label>Contact Person</label>
                      <input
                        type="text"
                        name="Contact_Person"
                        className="form-control"
                        placeholder="Enter Contact Person Name"
                        value={rowData.Contact_Person || ""}
                        onChange={handleInputChange}
                      />
                    </div>

                    </div>
                  <div className="form-row d-flex justify-content-start justify-content-lg-between flex-wrap flex-xl-nowrap flex-column flex-lg-row">                 
                      
                      <div className={`form-group ${formErrors.Contact_Mobile_No ? "fieldrequire" : ""}`}>
                      <label>Mobile Number</label>
                      <input
                        type="text"
                        name="Contact_Mobile_No"
                        className="form-control"
                        placeholder="Enter Mobile Number"
                        value={rowData.Contact_Mobile_No || ""}
                        onChange={handleInputChange}
                        inputMode="numeric"
                          onKeyDown={(e) => {
                            const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", " "];
                            const allowedChars = /^[\d+\-\s]$/;                            
                            if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "a") {
                              return;
                            }                            
                            if (!allowedChars.test(e.key) && !allowedKeys.includes(e.key)) {
                              e.preventDefault();
                            }
                          }}   
                      />
                      <small className="hide"><IconError/></small>   
                    </div>
                    <div className="form-group">
                      <label>E-Mail ID</label>
                      <input
                        type="email"
                        name="Contact_Email_Id"
                        className="form-control"
                        placeholder="Enter E-Mail ID"
                        value={rowData.Contact_Email_Id || ""}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>


                  <div className={`form-row d-flex justify-content-start justify-content-lg-between flex-wrap flex-xl-nowrap flex-column flex-lg-row ${formErrors.Customer_Type ? "fieldrequire" : ""}`}>
                    <div className="userrightslist">
                      <div className="userrights">Select Customer Type</div>
                      <ul className="d-flex flex-column flex-md-row justify-content-start justify-content-md-between gap-2 gap-md-2 gap-xl-0 flex-wrap flex-xl-nowrap">
                        {["Gulf Employee", "DSS", "Distributor", "Retailer", "Others"].map((type) => {
                          const normalizedType = type.replace(/\s+/g, "").toLowerCase();
                          const selectedType = (rowData.Customer_Type || "").replace(/\s+/g, "").toLowerCase();

                          return (
                            <li key={type}>
                              <input
                                className="checkbox"
                                type="checkbox"
                                id={normalizedType}
                                checked={selectedType === normalizedType}
                                onChange={() => handleCustomerTypeChange(type)}
                              />
                              <label className="checklabel" htmlFor={normalizedType}>{type}</label>
                            </li>
                          );
                        })}

                      </ul>
                       <small className="hide" style={{bottom:'40px'}}><IconError/></small>
                    </div>
                  </div>
                </div>

                <div className="form-savebtns d-flex justify-content-end align-items-center">
                  <Link to="/customers-list" className="btn cancelbtn">Back</Link>
                  <button type="submit" className="btn btngradiant" disabled={loading} >   {loading ? "Updating..." : "Update"} </button>
                </div>
              </motion.form>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
}
